import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/Home.vue';
import { Message } from 'element-ui';

Vue.use(VueRouter);

const routes = [
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/order/index'),
    meta: {
      isLogin: true,
    },
  },
  // {
  //   path: '/orderDetails',
  //   name: 'orderDetails',
  //   component: () => import("@/views/order/orderDetails"),
  //   meta: {
  //     isLogin: true
  //   }
  // },

  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/commodityIndex',
    name: 'CommodityIndex',
    component: () => import('@/views/home/commodityPage/CommodityIndex'),
  },
  {
    path: '/catIndex',
    name: 'CatIndex',
    component: () => import('@/views/shopping_cart/CatIndex'),
  },
  {
    path: '/personalCenter',
    name: 'PersonalCenter',
    component: () => import('@/views/personalCenter/Index'),
  },
  {
    path: '/orderIndex',
    name: 'Order',
    component: () => import('@/views/order/index'),
  },
  {
    path: '/AnnouncementDetails/:id',
    name: 'AnnouncementDetails',
    component: () => import('@/views/personalCenter/AnnouncementDetails'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.name == from.name) {
    return;
  }
  if (to.name !== 'Home') {
    if (localStorage.getItem('token')) {
      next();
    } else {
      localStorage.clear();
      // Message.info('Заходите.');
      setTimeout(() => {
        next({ name: 'Home' });
      }, 1500);
    }
  } else {
    next();
  }
});
